import { defineMessages } from 'react-intl';

const messages = defineMessages({
  titleCR: {
    description: 'checkout rates requested service title',
    defaultMessage: 'Checkout Rates',
    id: 'DyYcB3',
  },
  subtitleCR: {
    description: 'checkout rates requested service subtitle',
    defaultMessage: 'Requested via Checkout Rates',
    id: 'i56ous',
  },
  totalCost: {
    description: 'checkout rates requested service subtitle',
    defaultMessage: 'Total cost:',
    id: 'PpY5qC',
  },
  service: {
    description: 'delivery options requested service',
    defaultMessage: 'Service:',
    id: '3cNjp1',
  },
  optionType: {
    description: 'delivery options option type',
    defaultMessage: 'Pricing:',
    id: 'PpwemD',
  },
  shipments: {
    description: 'delivery options option type',
    defaultMessage: 'Shipment <b>{number}</b> of <b>{total}</b>',
    id: '4AAbiC',
  },
  deliveryTimeTitle: {
    description: 'deliviery options delivery time title',
    defaultMessage: 'Delivery Time:',
    id: '+XMWNm',
  },
  deliveryTimeMaxDays: {
    description: 'delivery options delivery time max days',
    defaultMessage: '{numberOfDays, plural, one {# day} other {# days}}',
    id: '4OFML+',
  },
  deliveryTimeRange: {
    description: 'delivery options delivery time range',
    defaultMessage: '{minNumberOfDays} - {maxNumberOfDays} days',
    id: 'yg84oY',
  },
  deliveryTimeSameDay: {
    description: 'delivery options delivery time same day',
    defaultMessage: 'Same Day',
    id: '2GpO6h',
  },
  shippingCost: {
    description: 'delivery options shipping cost',
    defaultMessage: 'Shipping Cost:',
    id: 'JMfukt',
  },
});

export default messages;
